export default "__VITE_ASSET__qy0tSwYn__"